import type { MatterViewModel } from '~/modules/matters/matters.types';
import { UserRole, type User } from '~/shared/types/connect';

/**
 * Resolves attorneys from loaded matter rows (`matter.attorney` from GraphQL).
 * Use for list/detail UI instead of mock store attorneys.
 */
export function buildGetAttorneyByIdFromMatters(
  matters: MatterViewModel[],
): (id: string) => User | undefined {
  const attorneyById = new Map<string, User>();
  for (const matter of matters) {
    const nested = matter.attorney;
    if (!nested) {
      continue;
    }
    if (!attorneyById.has(nested.id)) {
      attorneyById.set(nested.id, {
        id: nested.id,
        name: nested.name,
        email: nested.email,
        role: UserRole.ATTORNEY,
      });
    }
  }
  return (id: string) => attorneyById.get(id);
}
